/**
 * Bonus pack types
 */
export const BONUS_PACKS = {
  STARTER: 'starter',
  HIGHROLLER: 'highroller',
};
